export enum SEARCH_PROMOTED {
    /**
     * @value Add keywords
     */
    ADD_KEYWORDS = 'SEARCH_PROMOTED.ADD_KEYWORDS',
    /**
     * @value Activate Promoted results keywords in the %PAGE_LINK% to display your new promoted items in the search results list. Formerly promoted items will no longer be promoted.
     * @description Link to : SEARCH_PROMOTED.PAGE_LINK_TITLE
     */
    ADMIN_INFO_MESSAGE = 'SEARCH_PROMOTED.ADMIN_INFO_MESSAGE',
    /**
     * @value Change item
     */
    CHANGE_ITEM = 'SEARCH_PROMOTED.CHANGE_ITEM',
    DELETE_MANY_PROMOTION_ERROR = 'ADMIN.PROMOTED_RESULTS.DELETE_MANY_PROMOTION_ERROR',
    /**
     * @value {"one":"Promotion well deleted for `%LABEL%` +%COUNT% other","other":"Promotion well deleted for `%LABEL%` +%COUNT% others"}
     * @description Notification success when many promotion are well deleted
     */
    DELETE_MANY_PROMOTION_SUCCESS = 'ADMIN.PROMOTED_RESULTS.DELETE_MANY_PROMOTION_SUCCESS',
    /**
     * @value An error occurred while deleting the promotion for '%LABEL%'
     * @description error message displayed when something went wrong when the user tried to promote an item
     */
    DELETE_PROMOTION_ERROR = 'ADMIN.PROMOTED_RESULTS.DELETE_PROMOTION_ERROR',
    /**
     * @value Promotion well deleted for '%LABEL%'
     * @description text displayed in notification when the promotion was well deleted
     */
    DELETE_PROMOTION_SUCCESS = 'ADMIN.PROMOTED_RESULTS.DELETE_PROMOTION_SUCCESS',
    /**
     * @value Edit item
     */
    EDIT_PROMOTION_TITLE = 'SEARCH_PROMOTED.EDIT_PROMOTION_TITLE',
    /**
     * @value If you do not specify any group, the item will be promoted to all users who have access to this item.
     * @description Helper displayed below the group picker in prompted search admin.
     */
    GROUPS_TEXT_FIELD_HELPER = 'SEARCH_PROMOTED.GROUP_TEXT_FIELD_HELPER',
    /**
     * @value You can specify groups of users to whom you promote the item
     * @description label displayed above group picker in promoted search admin.
     */
    GROUPS_TEXT_FIELD_LABEL = 'SEARCH_PROMOTED.GROUP_TEXT_FIELD_LABEL',
    /**
     * @value Promoted date
     * @description Column title of the promoted date info. "Date de promotion" in french
     */
    ITEM_PROMOTED_DATE = 'ADMIN.PROMOTED_RESULTS.ITEM_PROMOTED_DATE',
    /**
     * @value Select a type of item to promote
     * @description Description displayed in the dialog where the user has to select which item type (content, community, article, post...) they want to promote. The dialog is displayed after clicking on the 'Promote an item' button from the promoted search admin interface.
     */
    ITEM_TYPE_DIALOG_DESC = 'SEARCH_PROMOTED.SELECT_ITEM_TYPE_DESC',
    /**
     * @value You must add at least one keyword to promote the item.
     * @description Error message displayed if the user does not add any keyword in the keywords textfield and tries to promote a search item.
     */
    KEYWORDS_TEXT_FIELD_ERROR_MESSAGE = 'SEARCH_PROMOTED.KEYWORDS_TEXT_FIELD_ERROR_MESSAGE',
    /**
     * @value You can define a word or a combination of words. It is not case-sensitive.
     * @description Helper displayed below the textfield that contains the keywords used to boost item position in search results
     */
    KEYWORDS_TEXT_FIELD_HELPER = 'SEARCH_PROMOTED.KEYWORDS_TEXT_FIELD_HELPER',
    /**
     * @value You can define a word or a combination of words with a maximum of 50 characters per instance. It is not case sensitive. Press “enter” to add the keyword.
     * @description Helper displayed below the textfield that contains the keywords used to boost item position in search results
     */
    KEYWORDS_TEXT_FIELD_HELPER2 = 'SEARCH_PROMOTED.KEYWORDS_TEXT_FIELD_HELPER_2',
    /**
     * @value Limit the promotion of the item to specific keywords
     * @description Description used for the textfield in which the user can add keywords to boost item position in search results
     */
    KEYWORDS_TEXT_FIELD_LABEL = 'SEARCH_PROMOTED.KEYWORDS_TEXT_FIELD_LABEL',
    /**
     * @value You have reached keywords limit, you cannot add more keywords.
     * @description Helper displayed below the keywords text field when the user has reached the maximum limit of keyword.
     */
    KEYWORDS_TEXT_FIELD_MAX_LIMIT_HELPER = 'SEARCH.PROMOTED.REACH_KEYWORD_LIMIT',
    /**
     * @value Keywords
     * @description Title of the section used to display keywords for promoted search. When a keyword is hit by search query, it will boost the promoted item in the first positions in search results.
     */
    KEYWORDS_TITLE = 'SEARCH_PROMOTED.KEYWORDS_TITLE',
    /**
     * @value You can promote a maximum of 1000 items
     */
    MAXIMUM_NUMBER_PROMOTION = 'SEARCH_PROMOTED.MAXIMUM_NUMBER_PROMOTION',
    /**
     * @value There are no promoted results
     * @description Message displayed when there are no promoted content found
     */
    NO_PROMOTED = 'ADMIN.PROMOTED_RESULTS.NO_PROMOTED',
    /**
     * @value All promoted results will be displayed here.<br />Promote result puts it forward in search results.
     * @description description of the empty state in the promoted results list
     */
    NO_PROMOTED_DESC = 'ADMIN.PROMOTED_RESULTS.NO_PROMOTED_DESC',
    /**
     * @value Feature management page
     * @description Link to: SEARCH_PROMOTED.ADMIN_INFO_MESSAGE
     */
    PAGE_LINK_TITLE = 'SEARCH_PROMOTED.PAGE_LINK_TITLE',
    /**
     * @value Select content
     * @description title of the content picker dialog
     */
    PICK_CONTENT = 'ADMIN.PROMOTED_RESULTS.PICK_CONTENT',
    /**
     * @value Promote
     * @description action to promote a content
     */
    PROMOTE = 'ADMIN.PROMOTED_RESULTS.PROMOTE',
    /**
     * @value Promoted results
     * @description title of the entry in the side navigation and of the admin page
     */
    PROMOTED_RESULTS_TITLE = 'ADMIN.PROMOTED_RESULTS.TITLE',
    /**
     * @value Promoted since
     * @description Column header for the column that displays the promotion date of a search result
     */
    PROMOTED_SINCE = 'SEARCH_PROMOTED.SINCE',
    /**
     * @value Promote an item
     * @description Button label displayed in the header of search promoted admin. Allow user to select an item to promote in search results.
     */
    PROMOTE_BUTTON_LABEL = 'SEARCH_PROMOTED.ADD_PROMOTION_BUTTON',
    /**
     * @value An error occurred while promoting '%LABEL%'
     * @description error message displayed when an error occurred while promoting an item
     */
    PROMOTE_ERROR = 'ADMIN.PROMOTED_RESULTS.PROMOTE_ERROR',
    /**
     * @value Promote item
     * @description Label of the button used to promote a search item
     */
    PROMOTE_ITEM_LABEL = 'SEARCH_PROMOTED.PROMOTE_ITEM_LABEL',
    PROMOTE_MANY_SUCCESS = 'ADMIN.PROMOTED_RESULTS.PROMOTE_MANY_SUCCESS',
    /**
     * @value Select content
     * @description Action label to select results to promote
     */
    PROMOTE_NEW = 'ADMIN.PROMOTED_RESULTS.PROMOTE_NEW',
    /**
     * @value Promotion added for '%LABEL%'
     * @description success message displayed when the item was well promoted
     */
    PROMOTE_SUCCESS = 'ADMIN.PROMOTED_RESULTS.PROMOTE_SUCCESS',
    /**
     * @value {"one":"Promotion restored for '%LABEL%' +1 other","other":"Promotion restored for '%LABEL%' +%COUNT% others"}
     * @description Success message when many promotion where restored
     */
    RESTORE_MANY_SUCCESS = 'ADMIN.PROMOTED_RESULTS.RESTORE_MANY_SUCCESS',
    /**
     * @value Promotion restored for '%LABEL%'
     * @description success message when 1 promotion was restored for an item
     */
    RESTORE_SUCCESS = 'ADMIN.PROMOTED_RESULTS.RESTORE_SUCCESS',
    /**
     * @value See more promoted
     * @description label of the action button used to display more promoted results
     */
    SEE_MORE_PROMOTED_RESULTS = 'FRONT.SEARCH.SEE_MORE_PROMOTED_RESULTS',
    /**
     * @value Delete the promotion
     * @description Action to remove the promotion for a result
     */
    UNPROMOTE = 'ADMIN.PROMOTED_RESULTS.UNPROMOTE',
    /**
     * @value Remove promotion
     * @description Label of the button used to remove promotion from a item (content, community, post...). Promoted items appear first in search result page when the query hit key word/item title...
     */
    UNPROMOTE_BUTTON_LABEL = 'SEARCH_PROMOTED.REMOVE_PROMOTION_BUTTON',
    /**
     * @value This item will no longer appear as a promoted result in the search result page.
     * @description Description in the modal displayed when after the user has clicked on the remove promotion button from the promoted result admin interface
     */
    UNPROMOTE_DESC = 'SEARCH_PROMOTED.UNPROMOTE_DESC',
    /**
     * @value {"one":"Delete 1 promotion","other":"Delete %COUNT% promotions"}
     * @description action label to delete many promotion
     */
    UNPROMOTE_MANY = 'ADMIN.PROMOTED_RESULTS.UNPROMOTE_MANY',
    /**
     * @value Remove item promotion?
     * @description Title of the modal displayed when the user clicks on the 'Delete promotion' button from the 'promoted search results' admin interface
     */
    UNPROMOTE_TITLE = 'SEARCH_PROMOTED.UNPROMOTE_TITLE',
}
